var Keys;
(function (Keys) {
    // Extend to your needs
    Keys["ArrowUp"] = "ArrowUp";
    Keys["ArrowDown"] = "ArrowDown";
    Keys["ArrowRight"] = "ArrowRight";
    Keys["ArrowLeft"] = "ArrowLeft";
    Keys["Escape"] = "Escape";
    Keys["Enter"] = "Enter";
    Keys["Tab"] = "Tab";
    Keys["Space"] = "Space";
    Keys["Home"] = "Home";
    Keys["End"] = "End";
})(Keys || (Keys = {}));
export default Keys;
//# sourceMappingURL=KeyboardKeys.js.map